var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comp,_vm._g(_vm._b({tag:"component",attrs:{"type":_vm.type,"loading":_vm.actionLoading || _vm.loading,"disabled":_vm.disabled},on:{"click":_vm.onAction}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }